import { Link } from 'react-router-dom';
import { DEMO_URL } from '../signup/SignupLayout';

/**
 * The marketing site's pill buttons: `primary` (navy) on light sections; `gold` and `ghost-dark` on
 * the navy band only.
 */
export type PricingCtaTone = 'primary' | 'gold' | 'ghost-dark';

/**
 * The page's call to action, in either of its two forms.
 *
 * With online signup open it is "Get started", into self-serve signup. With signup closed it is
 * "Talk to us", the same demo booking link the marketing site and the signup flow's unavailable
 * outcome use (`DEMO_URL`), opened in a new tab since it leaves RosterPilot.
 *
 * `tierName` gives each card's button its own accessible name ("Get started with Power 4"), so a
 * screen reader's list of links is not three identical "Get started" entries. The name always
 * starts with the visible words, so speech input that says what it sees still works.
 */
export const PricingCta = ({
  signupAvailable,
  tone = 'primary',
  block = false,
  tierName,
  testId,
}: {
  signupAvailable: boolean;
  tone?: PricingCtaTone;
  /** Full width, as on a tier card. */
  block?: boolean;
  tierName?: string;
  testId?: string;
}) => {
  const className = `mk-btn mk-btn--${tone}${block ? ' mk-btn--block' : ''}`;

  if (signupAvailable) {
    return (
      <Link
        to="/signup"
        className={className}
        aria-label={tierName ? `Get started with ${tierName}` : undefined}
        data-testid={testId}
      >
        Get started
      </Link>
    );
  }

  return (
    <a
      href={DEMO_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label={tierName ? `Talk to us about ${tierName} (opens in a new tab)` : undefined}
      data-testid={testId}
    >
      Talk to us
      {!tierName && <span className="pricing-visually-hidden"> (opens in a new tab)</span>}
    </a>
  );
};
